import { useMemo } from 'react';
import { connect } from 'react-redux';

import { getOpenedTaskProjectAndSectionLabelList } from '../../../../../redux/tasks/tasksToProjectsRelation/selectors';

const TaskDetailsArchivedLabel = ({ projectAndSectionLabelList, projectId }) => {
  const isArchived = useMemo(() =>
    projectAndSectionLabelList?.[projectId]?.archived,
    [projectAndSectionLabelList, projectId]
  );
  return isArchived ? (
    <div className="h-9 bg-slate-200 flex align-center justify-center text-slate-600 px-5 sticky top-0 z-[10]">
      Archived
    </div>
  ) : null;
}

const mapStateToProps = (state) => ({
  projectAndSectionLabelList: getOpenedTaskProjectAndSectionLabelList(state),
});

export default connect(mapStateToProps)(TaskDetailsArchivedLabel);
